import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import getUprateLogo from "../../images/getUprateLogo-blank.png";
import AuthWrapper from "../AuthWrapper";
import { AuthService } from "../../services/AuthService";
import "./styles/login.css";

function Login({ setIsAuthenticated }) {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isExiting, setIsExiting] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  useEffect(() => {
    async function validateAuth() {
      if (AuthService.isAuthenticated()) {
        const isValid = await AuthService.validateToken();
        if (isValid) {
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
        }
      }
    }
    validateAuth();
  }, [setIsAuthenticated]);

  useEffect(() => {
    /* Body, html overflow: hidden !improtant; */
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    const result = await AuthService.login(email, password);

    if (result.success) {
      setIsAuthenticated(true);
    } else {
      setError(result.message || "Login failed. Please check your credentials.");
      setIsAuthenticated(false);
    }
  };

  const navigateWithTransition = (path) => {
    setIsExiting(true);
    const form = document.querySelector('.form');
    const authLeft = document.querySelector('.auth-left');

    authLeft.classList.remove('register', 'password-reset');
    if (form) form.classList.remove('entered');
    if (form) form.classList.add('exiting');
    if (authLeft) authLeft.classList.add('exiting');

    if (path === '/sign-up') {
      if (authLeft) authLeft.classList.add('register');
    } else if (path === '/password-reset') {
      if (authLeft) authLeft.classList.add('password-reset');
    }

    setTimeout(() => {
      navigate(path);
    }, 650);
  };

  return (
    <AuthWrapper 
      rightContent={null}
    >
      <CSSTransition 
        in={!isExiting} 
        appear={true} 
        timeout={650} 
        classNames="page-transition"
        unmountOnExit
      >
        <div className="glass-box-auth">
          <h1 className="title">Login</h1>
          <p className="subtitle">Sign in with your email and password</p>

          <form className="form entered" onSubmit={handleLogin}>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="form-group password-group">
              <label htmlFor="password">Password</label>
              <input
                id="password"
                type={showPassword ? "text" : "password"}
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <button
                type="button"
                onClick={togglePasswordVisibility}
                className="toggle-password"
              >
                {showPassword ? "Hide" : "Show"}
              </button>
            </div>

            <div className="form-actions">
              <label className="remember-me">
                <input type="checkbox" />
                Remember me
              </label>
              {/*<a
                onClick={(e) => {
                  e.preventDefault();
                  navigateWithTransition('/password-reset');
                }}
                href="/password-reset"
                className="forgot-password"
              >
                Forgot password?
              </a>*/}
            </div>

            <button type="submit" className="login-button">
              Login
            </button>
          </form>

          <div className="transition-links">
            <p className="register">
              Don't have an account?{" "}
              <a
                onClick={(e) => {
                  e.preventDefault();
                  navigateWithTransition('/sign-up');
                }}
                href="/sign-up"
                className="register-link"
              >
                Register
              </a>
            </p>
          </div>
          
          {error && <p className="error">{error}</p>}
        </div>
      </CSSTransition>
    </AuthWrapper>
  );
}

export default Login;